import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=c2806474&"
import script from "./Impressum.vue?vue&type=script&lang=js&"
export * from "./Impressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports